import { Box, Typography } from "@mui/material";
import React from "react";
import Knowmorebtn from "../../components/button/Knowmorebtn";

const ThinkingCard = ({ ThinkingCardImage }) => {
  return (
    <Box
      sx={{
        width: "20rem",
        height: "26rem",
        borderRadius: "1.2rem",
        padding: "0.8rem",
        backgroundColor: "rgba(255, 255, 255, 1)",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "10rem",
          borderRadius: "1.2rem",
        }}
      >
        <Box sx={{ borderRadius: "1rem", overflow: "hidden" }}>
          <img
            src={ThinkingCardImage}
            alt=""
            width="100%"
            style={{ borderRadius: "0.8rem" }}
          />
        </Box>
      </Box>
      <Box>
        <Typography
          variant="h4"
          sx={{
            fontFamily: "Montserrat",
            fontSize: "1.2rem",
            fontWeight: "500",
            marginTop: "0.8rem",
          }}
        >
          <span style={{ color: "rgba(255, 102, 0, 1)" }}>AI and the CEO</span>
        </Typography>
        <Typography
          sx={{
            marginTop: "0.8rem",
            fontFamily: "Plus Jakarta Sans",
            color: "#333333",
            fontWeight: "300",
          }}
        >
          The relevance of the title is high because AI appears to be the
          ultimate enabler of the corporate world, and the CEO is the ultimate
          decision-maker of that world.{" "}
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "end",
            marginTop: "0.8rem",
          }}
        >
          <Knowmorebtn content="Read more" link="/thinkingdetailpage" />
        </Box>
      </Box>
    </Box>
  );
};

export default ThinkingCard;
